import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import ImageLibraryTable from "../../components/ContentManagement/ImageLibraryTable"


export default function ContentImageLibraryPage () {

    //#region Initialization
    const breadcrumbsData = [
        { name: 'Content List', path: `${DASHBOARD_ROOT}/content-management/` },
        { name: 'Image Library', path: `${DASHBOARD_ROOT}/content-management/library/images` },
    ];


    //#endregion Initialization

    return (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />

            <ImageLibraryTable limit={10} />

        </>
    )
    
}

